import posthog from 'posthog-js';

// Inicializar PostHog apenas se a chave de API estiver configurada
const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com';

// Initialize PostHog
if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // PWA - controle manual de pageviews
    capture_pageview: false,
    capture_pageleave: true,
    // Session recording para ver o que usuário fez antes do erro
    session_recording: {
      recordCrossOriginIframes: true,
    },
    // Captura automática de erros
    autocapture: true,
    // Captura console errors automaticamente
    capture_performance: true,
  });

  console.log('[PostHog] Initialized successfully');
} else {
  console.log('[PostHog] Not initialized - VITE_PUBLIC_POSTHOG_KEY not found');
}

// Helper para verificar se PostHog está configurado
export const isPostHogConfigured = () => Boolean(POSTHOG_KEY);

// Export singleton
export { posthog };

